import { NumberFormatValues } from "@common/schemas/domains/reportSettings/number-format-setting.schema";
import { formatPreviewPercent } from "./formatPreviewAmount";
import styles from "./ReportPreview.module.scss";

interface Props {
    value: number | undefined;
    numberFormat: NumberFormatValues;
}

/** Percent column that paints red the same way `AmountCell` does. */
export const PercentCell = ({ value, numberFormat }: Props) => {
    if (value === undefined) {
        return <span className={styles.percentCell} />;
    }
    const percent = formatPreviewPercent(value, numberFormat);
    return (
        <span
            className={styles.percentCell}
            data-negative={
                percent.isNegative && numberFormat.isNegativeInRed
                    ? true
                    : undefined
            }
        >
            {percent.text}
        </span>
    );
};
